<template>
    <div>
        <apexchart type="line" height="550" :options="chartOptions" :series="chartSeries"/>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    zoom: {
                        autoScaleYaxis: true
                    },
                    height: 550,
                    type: 'line',
                    toolbar: {
                        show: true
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    width: 3
                },
                markers: {
                    size: 4
                },
                tooltip: {
                    shared: false,
                    intersect: true,
                    x: {
                        formatter: (val) => val + '%'
                    }
                },
                xaxis: {
                    type: 'categories',
                    categories: this.categories,
                    title: {
                        text: 'Semana de alojamento'
                    },
                    labels: {
                        style: {
                            colors: '#000000de'
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: 'Percentual'
                    }
                },
            }
        },
        chartSeries() {
            let semanas = this.values[0].data.length;
            let batches = this.values.map(v => ({
                name: v.name,
                data: v.data,
                type: 'line'
            }));
            let limits = [];
            for (const key in this.limitData) {
                const filler = Array(semanas - this.limitData[key].pontos.length).fill(null)

                limits.push(
                    {   type: 'line',
                        name: 'Limite Mortalidade: ' +this.limitData[key].nmTabela,
                        data: [...this.limitData[key].pontos.pontos.sort((a, b) => {
                            return (
                                a.nrDia - b.nrDia
                            )
                        }).map(v => v.mortalidade), ...filler] });
            }

            return [...batches, ...limits];
        },
        chartLabels() {
            return this.values.map(v => v.name)
        }
        ,
        chartMax() {
            return Math.max(...this.values.map(v => v.max))
        }
        ,
    },
    props: {
        values: Array,
        categories: Array,
        limitData: Array
    }
}
</script>


